var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiv3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 120,
    viewBox: "0 0 109 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 109,
    height: 120,
    rx: 20,
    fill: "#E6E6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8154 93.0039H34.1795C34.628 93.0039 34.995 92.6327 34.995 92.1789V72.0984C34.995 71.6364 34.628 71.2734 34.1795 71.2734H23.8154C23.3669 71.2734 23 71.6364 23 72.0984V92.1789C23 92.6327 23.3669 93.0039 23.8154 93.0039Z",
    fill: "#00A90B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8174 65.6953C40.3689 65.6953 40.002 66.0666 40.002 66.5203V92.1778C40.002 92.6316 40.3689 93.0028 40.8174 93.0028H51.1815C51.63 93.0028 51.9969 92.6316 51.9969 92.1778V66.5203C51.9969 66.0666 51.63 65.6953 51.1815 65.6953H40.8174Z",
    fill: "#00A90B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8184 57.75C57.3699 57.75 57.0029 58.113 57.0029 58.575V92.1855C57.0029 92.6393 57.3699 93.0105 57.8184 93.0105H68.1825C68.6309 93.0105 68.9979 92.6393 68.9979 92.1855V58.575C68.9979 58.113 68.6309 57.75 68.1825 57.75H57.8184Z",
    fill: "#00A90B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0049 50.6062V92.178C74.0049 92.6317 74.3718 93.003 74.8203 93.003H85.1844C85.6329 93.003 85.9998 92.6317 85.9998 92.178V50.6062C85.9998 50.1525 85.6329 49.7812 85.1844 49.7812H74.8203C74.3718 49.7812 74.0049 50.1525 74.0049 50.6062Z",
    fill: "#00A90B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.002 54.6577C49.828 54.6577 67.8408 54.6412 79.9173 35.5259L82.8528 37.2419C82.9833 37.3162 83.1219 37.3492 83.2606 37.3492C83.3992 37.3492 83.546 37.3162 83.6683 37.2419C83.9211 37.0934 84.076 36.8212 84.076 36.5242V27.8369C84.076 27.5399 83.9129 27.2677 83.6683 27.1192C83.4155 26.9707 83.1056 26.9707 82.8528 27.1192L75.408 31.4669C75.1552 31.6154 75.0003 31.8877 75.0003 32.1847C75.0003 32.4817 75.1552 32.7539 75.408 32.9024L78.5066 34.7092C67.5065 52.1084 52.4618 53.0159 29.002 53.0159C28.5535 53.0159 28.1865 53.3872 28.1865 53.8409C28.1865 54.2947 28.5535 54.6659 29.002 54.6659V54.6577Z",
    fill: "#00A90B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiv3);
export default __webpack_public_path__ + "static/media/div3.1d0de5f9e739f55c58bdf752c3a016ec.svg";
export { ForwardRef as ReactComponent };